module.exports = __webpack_public_path__ + "img/mini-009.94769588.jpg";